
import { Options, Vue } from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'

@Options({
  name: 'ConfirmDialog',
  components: {
    KeyenceHTHardKeyButton,
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
})
export default class ConfirmDialog extends Vue {
  @Prop({ type: Boolean, default: false })
  modelValue!: boolean

  @Prop({ type: String, default: '' })
  title!: string

  @Prop({ type: String, default: '' })
  message!: string

  @Prop({ type: String, default: 'OK' })
  confirmText!: string

  @Prop({ type: String, default: 'Cancel' })
  cancelText!: string

  @Prop({ type: String, default: 'primary' })
  confirmType!: 'primary' | 'danger' | 'warning' | 'success' | 'info'

  @Prop({ type: String, default: '90%' })
  width!: string

  @Prop({ type: String })
  confirmHardKey?: string

  KeyenceHardKey = KeyenceHardKey

  get isVisible(): boolean {
    return this.modelValue
  }

  set isVisible(value: boolean) {
    this.updateModelValue(value)
  }

  get isKeyenceEnterpriseBrowser(): boolean {
    return isKeyenceEnterpriseBrowser()
  }

  @Emit('update:modelValue')
  updateModelValue(value: boolean): boolean {
    return value
  }

  @Emit('confirm')
  onConfirm(): void {
    this.isVisible = false
  }

  @Emit('cancel')
  onCancel(): void {
    this.isVisible = false
  }
}
